import { useMemo } from 'react';
import { QueryParams } from 'shared/types';
import { PriceFamily } from '../models';
import useFetchByParams from 'shared/hooks/useFetchByParams';
import { fetchPriceFamilies, selectPriceFamilies, selectPriceFamiliesLoading } from 'features/products/store/price.slice';
import { useRequestQuery } from 'shared/hooks/useRequest';
import { priceFamilyService } from '../services';

export const usePriceFamiliesQuery = (options: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...options, isActive: 1 };

    return [queryParams];
  }, []);
};

export const usePriceFamilies = (query: QueryParams) => {
  return useFetchByParams<PriceFamily[]>({
    action: fetchPriceFamilies,
    dataSelector: selectPriceFamilies,
    loadingSelector: selectPriceFamiliesLoading,
    params: query,
  });
};

export const usePriceFamilyRequest = (initialParams?: QueryParams, cb?: (data: PriceFamily[]) => void) => {
  const action = async (params?: QueryParams): Promise<PriceFamily[]> => {
    if (params && ('productTypeId[]' in params || params.productTypeId)) {
      const response = await priceFamilyService.getPriceFamilies({ ...params, isActive: 1 });
      return response;
    }
    return [];
  };

  return useRequestQuery<QueryParams, PriceFamily[]>({
    action: action,
    defaultValue: [],
    params: initialParams,
    autoFetch: true,
    onSuccess: (data) => {
      cb?.(data);
    },
  });
};
